<template lang="pug">
vm-row(vm-w="12" vm-type="flex" vm-justify="space-between" class="information__wrapper")
  modal-sendings-and-receptions(:purchase_order_detail_id="purchase_order_detail_id")
  modal-supplier-shipment(:form="supplier" :read_only="true")
  vm-col(vm-sm=12 vm-md=6 vm-lg=12)
    vm-col(vm-sm=12 vm-md=6 vm-lg=4 class="gutters")
      .card
        .card-body
          h4.purchase__order_title Ordenes de Compra
          span.text__helper Selecciona la orden de compra de la cual deseas ver el detalle.
          .list__wrapper_purchase
            .list__item__wrapper(v-for="(item, index) in purchase_orders" :key="index" v-if="index === 0")
              input.radio__button(type="radio" :id="item.id" :value="item" v-model="selected" ref="first")
              label.text__purchase(:for="item.id") {{ item.folio }}
              label.status__display(:for="item.id" :style="`background-color: ${colorStatus(item.status)}`") {{ item.status_display }}
            .list__item__wrapper(v-for="(item, index) in purchase_orders" :key="index" v-if="index > 0")
              input.radio__button(type="radio" :id="item.id" :value="item" v-model="selected")
              label.text__purchase(:for="item.id") {{ item.folio }}
              label.status__display(:for="item.id" :style="`background-color: ${colorStatus(item.status)}`") {{ item.status_display }}
    vm-col(vm-sm=12 vm-md=6 vm-lg=8)
      vm-col(vm-sm=12 vm-md=6 vm-lg=12 class="gutters")
        .card
          .card-body
            h4.purchase__order_title Detalles de la orden de compra: # {{ folio }}
            vm-row(vm-w="12" vm-type="flex" vm-align="center" vm-justify="center" class="p-0")
              vm-col(vm-sm=12 vm-md=6 vm-lg=5 class="p-0" vm-type="flex" vm-align="center" vm-justify="center")
                span.text-center Proveedor:
                  label.text__supplier {{ supplier_name }}
              vm-col(vm-sm=12 vm-md=6 vm-lg=5 class="p-0" vm-type="flex" vm-align="center" vm-justify="center")
                span.text-center total:
                  label.text__supplier {{ total | currency }}
            vm-row(vm-w="12" vm-type="flex" vm-justify="space-around" class="p-0")
              vm-col(vm-w=12 class="p-0" )
                vm-table(max-height="350px" :data="receptions" class="table")
                  template(slot="thead")
                    vm-th(:key="index" v-if="column !== 'id'" v-for="(column, index) in columns") {{ $t('receptions.' + column) }}
                  template(slot-scope="{data}")
                    vm-tr(:data="tr" :key="indextr" v-for="(tr, indextr) in data")
                      vm-td(:data="data[indextr][column]" :key="index" v-if="column !== 'id'" v-for="(column, index) in columns")
                        slot(v-if="column === 'product'") {{ data[indextr][column].name }}
                        slot(v-if="column === 'quantity'") {{ data[indextr][column] }}
                        slot(v-if="column === 'total_receptions_all'") {{ data[indextr][column] }}
                        slot(v-if="column === 'actions'")
                          .actions__wrapper
                            vm-button(type="flat" icon="eye-outline" color="#026481" @click="showSendingDetails(data[indextr])")
    vm-row(vm-w="12" vm-type="flex" vm-justify="space-between")
      vm-col(vm-w=12 class="gutters")
        .card
          .card-body
            h4.purchase__order_title Envios de proveedor: # {{ folio }}
            vm-row(vm-w="12" vm-type="flex" vm-align="center" vm-justify="center" class="p-0")
              vm-col(vm-sm=12 vm-md=6 vm-lg=5 class="p-0" vm-type="flex" vm-align="center" vm-justify="center")
                span.text-center Proveedor:
                  label.text__supplier {{ supplier_name }}
            vm-table(max-height="350px" :data="supplierShippments" class="table")
              template(slot="thead")
                vm-th(:key="index" v-if="column !== 'id'" v-for="(column, index) in columnsSupplier") {{ $t('supplier_shippment.' + column) }}
              template(slot-scope="{data}")
                vm-tr(:data="tr" :key="indextr" v-for="(tr, indextr) in data")
                  vm-td(:data="data[indextr][column]" :key="index" v-if="column !== 'id'" v-for="(column, index) in columnsSupplier")
                    slot(v-if="column == 'parcel'") {{data[indextr][column]}}
                    slot(v-if="column == 'guide_number'") {{data[indextr][column]}}
                    slot(v-if="column == 'shipping_date'") {{data[indextr][column] | moment('DD-MMMM-YYYY')}}
                    slot(v-if="column == 'arrival_date'") {{data[indextr][column] | moment('DD-MMMM-YYYY')}}
                    slot(v-if="column == 'created_by'") {{data[indextr]['user'].name}}
                    slot(v-if="column == 'actions'")
                      .actions__wrapper
                        vm-button(type="flat" icon="eye-outline" color="#026481" @click="showSupplierShipmentDetail(data[indextr])")
</template>

<script>
import { createNamespacedHelpers } from 'vuex'
import ModalSendingsAndReceptions from '@/components/modals/ModalSendingsAndReceptions.vue'
import ModalSupplierShipment from '@/components/modals/ModalSupplierShipment.vue'
const { mapGetters, mapActions } = createNamespacedHelpers('Receptions')

export default {
  name: 'PurchaseOrdersComponent',
  components: {
    ModalSendingsAndReceptions,
    ModalSupplierShipment
  },
  props: {
    sale: {
      type: Object,
      default: () => {
      }
    }
  },
  data: () => ({
    selected: 1,
    supplier_name: '...',
    folio: '...',
    total: 0.00,
    purchase_order_detail_id: null,
    supplier: '',
    columns: [
      'product',
      'quantity',
      'total_receptions_all',
      'actions'
    ],
    columnsSupplier: [
      'parcel',
      'guide_number',
      'shipping_date',
      'arrival_date',
      'created_by',
      'actions'
    ]
  }),
  computed: {
    ...mapGetters(['receptions', 'supplierShippments']),
    purchase_orders () {
      if (this.sale.supplier_quotation) {
        return this.sale.supplier_quotation
      }
    }
  },
  watch: {
    async selected (purchaseOrder) {
      this.supplier_name = purchaseOrder.supplier.name
      this.folio = purchaseOrder.folio
      this.total = purchaseOrder.total
      await this.loadPurchaseOrderDetails({ purchase_order_id: purchaseOrder.id }).then(() => {
        this.loadSupplierShipments({ purchase_order_id: purchaseOrder.id })
      })
    }
  },
  methods: {
    ...mapActions(['loadPurchaseOrderDetails', 'setModalReceptionVisible', 'loadSupplierShipments', 'setModalSupplierShipmentVisible', 'resetShipmentsDetails', 'setShipmentsDetails']),
    colorStatus (code) {
      switch (code) {
        case 1:
          return '#026481'
        case 2:
          return 'rgb(255, 130, 0)'
        case 3:
          return 'rgb(242, 19, 93)'
        case 4:
          return 'rgb(23, 201, 100)'
        case 5:
          return '#FFD000'
      }
    },
    defaultPurchaseOrder () {
      this.$refs.first[0].click()
    },
    showSendingDetails (data) {
      this.purchase_order_detail_id = data.id
      this.setModalReceptionVisible(true)
    },
    showSupplierShipmentDetail (data) {
      this.resetShipmentsDetails()
      this.supplier = data
      this.setShipmentsDetails(data.details)
      this.setModalSupplierShipmentVisible(true)
    }
  }
}
</script>

<style lang="scss" scoped>
.information__wrapper {
  margin-top: 25px;
  .card {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 10px !important;
    height: 100% !important;
    .card-body {
      padding: 10px !important;
      width: 100%;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      .icon__wrapper {
        padding: 10px !important;
        border-radius: 0.5em;
        background-color: #dfdfdf;
      }
    }
  }
}

.purchase__order_title {
  font-weight: bold;
}

.text__helper {
  font-size: 16px;
  text-align: center;
}

.list__wrapper_supplier,
.list__wrapper_purchase {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  margin-top: 25px;
  padding-left: 0 !important;
  .list__item__wrapper {
    width: 100%;
    padding-left: 0 !important;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 10px;
    border-bottom: 1px solid #94949493;
    .radio__button {
      padding: 10px;
      cursor: pointer;
    }
    .text__purchase {
      padding: 10px;
      font-size: 20px;
      font-weight: bold;
      cursor: pointer;
    }
    .status__display {
      font-size: 12px;
      border-radius: 0.5em;
      box-shadow: 0px 0px 10px 5px rgba(0,0,0,0.2);
      padding: 5px 10px;
      color: #fff;
      cursor: pointer;
    }
  }
}

.text__supplier {
  color: #026481;
  font-weight: bold;
}

.table {
  padding-left: 0 !important;
  .vm-table-text {
    padding-left: 0 !important;
  }
}
/* Helpers */
.gutters {
  padding: 20px;
}
.h-100 {
  height: 100%;
}

.p-0 {
  padding: 0 !important;
}

.input__wrapper,
.actions__wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
